import { RentDetailsProdSelectionAbstract } from "./RentDetailsProdSelectionAbstract";
import { RentalProdSelectionTimings } from "../../../../Models/Rental/Details/RentalProdSelectionTimings";
import { RentDetailsPackItemSelectionSection } from "../Components/RentDetailsPackItemSelectionSection";
import { RequestHelper } from "../../../../Lib/Helper/RequestHelper";
import { ForeignCurrencyPriceHelper } from "../../../../Lib/Helper/ForeignCurrencyPriceHelper";

export class RentDetailsProdSelectPackHandler extends RentDetailsProdSelectionAbstract {
    private rentalPackageSelectionSections: RentDetailsPackItemSelectionSection[] = [];

    constructor(prodSelectionTimings: RentalProdSelectionTimings, packageList: any, foreignCurrencyHelper?: ForeignCurrencyPriceHelper) {
        super(prodSelectionTimings);
        const rentalPackageWrappers = document.getElementsByClassName('rental_details__package_wrapper');

        for (let i = 0; i < rentalPackageWrappers.length; i++) {
            const wrapperElement = rentalPackageWrappers[i] as HTMLElement;
            const rentalPackSelectionSection = new RentDetailsPackItemSelectionSection(wrapperElement, packageList, foreignCurrencyHelper);
            this.rentalPackageSelectionSections.push(rentalPackSelectionSection);
        }
    }

    upDateAllPriceLabels() {
        for (let i = 0; i < this.rentalPackageSelectionSections.length; i++) {
            const selectionComp: RentDetailsPackItemSelectionSection = this.rentalPackageSelectionSections[i];
            selectionComp.updatePriceLabels();
        }
    }

    getSelectionTotalPrice(): number {
        let selectionTotalPrice = 0;

        for (let i = 0; i < this.rentalPackageSelectionSections.length; i++) {
            const selectionComp: RentDetailsPackItemSelectionSection = this.rentalPackageSelectionSections[i];
            const packPriceTotal = selectionComp.getPackageTotalPrice();
            selectionTotalPrice += packPriceTotal;
        }

        return selectionTotalPrice;
    }

    getAllProductsCount(): number {
        let selectionTotalCount = 0;

        for (let i = 0; i < this.rentalPackageSelectionSections.length; i++) {
            const selectionComp: RentDetailsPackItemSelectionSection = this.rentalPackageSelectionSections[i];
            selectionTotalCount += selectionComp.getPackagesSelectedCount();
        }

        return selectionTotalCount;
    }

    protected createPostData(): any {

        let selectedPackages = [];

        for (let i = 0; i < this.rentalPackageSelectionSections.length; i++) {
            const tempPack = this.rentalPackageSelectionSections[i];
            if (tempPack.getPackagesSelectedCount() < 1) {
                continue;
            }
            const postDataPack = tempPack.getPostData();
            selectedPackages = selectedPackages.concat(postDataPack);
        }

        const data = {
            selectedLocationId: this.getSelectedLocationId(),
            startSoapDate: this.prodSelectionTimings.startSoapDate,
            durationIdentifier: this.prodSelectionTimings.durationIdentifier,
            pickupTimeId: this.prodSelectionTimings.pickUpTimeId,
            rentalDetailsSelectedPackages: selectedPackages
        };

        return data;
    }

    proceed() {
        const data = this.createPostData();
        const requestHelper = new RequestHelper();
        requestHelper.postToUrl(`/${cultureInfo}/RentalRiderDetails/RiderDetailsPack`, data, {});
    }
}